import React from 'react';

export function DestSessionChooser({ sites, destSites, destSessions, value, onChange }) {
  if (destSites.length === 0) return null;
  return (
    <div className="space-y-2 border-t border-slate-100 pt-3" data-testid="cost-session-chooser">
      <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Destination session for costs</p>
      {destSites.map(id => {
        const site = sites.find(s => String(s.id) === id);
        const opts = destSessions[id] || [];
        const chosen = opts.find(o => String(o.session_id) === String(value[id]));
        return (
          <div key={id} className="space-y-1">
            <label className="text-xs text-slate-600 block">{site?.name || `Site #${id}`}</label>
            {opts.length === 0 ? (
              <p className="text-xs text-slate-400" data-testid={`cost-session-none-${id}`}>
                No draft or in-progress session — costs cannot be copied to this site.
              </p>
            ) : (
              <select
                className="w-full h-8 rounded border border-slate-200 text-xs px-2"
                value={value[id] || ''}
                onChange={e => onChange(id, e.target.value)}
                data-testid={`cost-session-select-${id}`}
              >
                <option value="">— choose session —</option>
                {opts.map(o => (
                  <option key={o.session_id} value={o.session_id}>
                    {o.reference} · {o.status} · {o.session_date} · {o.opening_rows_costed}/{o.opening_rows} rows costed
                  </option>
                ))}
              </select>
            )}
            {chosen && chosen.opening_rows_costed > 0 && (
              <p className="text-xs text-amber-700" data-testid={`cost-session-populated-${id}`}>
                Already populated: {chosen.opening_rows_costed} costed opening rows (£{chosen.opening_value_total.toFixed(2)}).
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
